{
  "title": "Scatter",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "6th-level conjuration",
  "level": 6,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V",
  "duration": "Instantaneous",
  "description": [
    "The air quivers around up to five creatures of your choice that you can see within range. An unwilling creature must succeed on a Wisdom saving throw to resist this spell. You teleport each affected target to an unoccupied space that you can see within 120 feet of you. That space must be on the ground or on a floor."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
